import axios from 'axios';

export const clientProducerApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/client-producer`,
    headers: {
        'Content-Type': 'application/json'
    }
})